export default __webpack_public_path__ + "static/media/CheckCircle_Blue.48ad4044.png";